import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initGA } from './utils/analytics';

initGA();

const widgetDivs = document.querySelectorAll('.calque-bbys-quiz-widget');

// Inject our React App into each widget div
widgetDivs.forEach(div => {
  const root = ReactDOM.createRoot(div); // Create a root for each div
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
